import { Event } from '../Event'
import { ViewerContext } from '../../constants'

export type FeedbackSubmittedSourceKey =
  | 'account-settings'
  | 'curations-page'
  | 'curations-product-page'
  | 'department-page'
  | 'experience-booking-page'
  | 'experience-details-page'
  | 'nav-bar'
  | 'order-receipt'
  | 'product-page'

export interface FeedbackSubmittedEventProperties {
  feedback_type: string
  feedback: string
  disappointment_level?: string
  suggestion?: string
  can_contact?: string
  source_key: FeedbackSubmittedSourceKey
}

export class FeedbackSubmittedEvent extends Event<FeedbackSubmittedEventProperties> {
  static displayName = 'Feedback Submitted'

  static allowedViewerContexts = [ViewerContext.Consumer]
}
